<template>
	<v-card class="nav-panel" rounded="xl">
		<div class="nav-panel__header">
			<v-icon color="primary">store</v-icon>
			<span class="nav-panel__title">{{ t('Visits') }}</span>
			<v-btn icon variant="text" size="small" :title="t('SFA Planning')" :aria-label="t('SFA Planning')" @click="act(openPlanning)">
				<v-icon>calendar_month</v-icon>
			</v-btn>
			<v-btn icon variant="text" size="small" :title="t('GeolocTitleBypassCode')" :aria-label="t('GeolocTitleBypassCode')" @click="act(enterBypassCode)">
				<v-icon>key</v-icon>
			</v-btn>
			<v-btn icon variant="text" size="small" :title="t('Synchronize')" :aria-label="t('Synchronize')" @click="reloadVisits">
				<v-icon>sync</v-icon>
			</v-btn>
		</div>
		<v-divider />

		<v-list v-if="hasVisits" class="nav-panel__list">
			<template v-for="section in sections" :key="section.key">
				<template v-if="section.items.length">
					<v-list-subheader class="nav-panel__section">
						<v-icon size="18">{{ section.icon }}</v-icon>
						<span>{{ t(section.titleKey) }}</span>
						<v-btn v-if="section.key === 'late'" icon variant="text" size="x-small" class="nav-panel__section-action" :title="t('CancelAllLatesConfirmation')" :aria-label="t('CancelAllLatesConfirmation')" @click="act(cancelLateVisits)">
							<v-icon>cancel</v-icon>
						</v-btn>
					</v-list-subheader>
					<v-list-item v-for="item in section.items" :key="item.key" link class="nav-panel__item" @click="act(() => openVisit(item.key))">
						<template #prepend>
							<v-avatar v-if="item.logo" size="36" rounded="lg" border class="nav-panel__logo">
								<v-img :src="item.logo" alt="" :cover="false" />
							</v-avatar>
							<v-avatar v-else color="primary" variant="tonal" size="36" rounded="lg">
								<v-icon size="20">store</v-icon>
							</v-avatar>
						</template>
						<v-list-item-title class="nav-panel__item-title">{{ item.label }}</v-list-item-title>
						<div class="nav-panel__item-meta">{{ item.period }}</div>
						<div class="nav-panel__item-text">{{ item.subtitle }}</div>
						<template #append>
							<v-btn v-if="item.ready" icon variant="text" color="primary" @click.stop="act(() => startVisit(item.key))">
								<v-icon>play_circle</v-icon>
							</v-btn>
							<v-btn icon variant="text" @click.stop="act(() => cancelVisit(item.key))">
								<v-icon>cancel</v-icon>
							</v-btn>
						</template>
					</v-list-item>
				</template>
			</template>
		</v-list>

		<div v-else class="nav-panel__empty">
			<v-icon size="40">event_available</v-icon>
			<p>{{ t('NoData') }}</p>
		</div>
	</v-card>
</template>

<script setup>
import { computed } from 'vue';
import { legacyNav } from '@/iframe/legacyNavState';
import { cancelLateVisits, cancelVisit, enterBypassCode, openPlanning, openVisit, reloadVisits, startVisit } from '@/iframe/legacyNavActions';
import { useTranslator } from '@/composables/useTranslator';

const emit = defineEmits(['close']);
const t = useTranslator();

const sections = computed(() => [
	{ key: 'current', titleKey: 'CurrentVisits', icon: 'play_circle', items: legacyNav.visits.current },
	{ key: 'preparation', titleKey: 'PreparationVisits', icon: 'pause_circle', items: legacyNav.visits.preparation },
	{ key: 'late', titleKey: 'LatesVisits', icon: 'history', items: legacyNav.visits.late },
]);
const hasVisits = computed(() => sections.value.some((section) => section.items.length));

const act = (action) => {
	emit('close');
	action();
};
</script>
